import React from "react";
import "./sidebar-header.css";

export function SidebarHeader({
	children,
	className,
	style,
}: {
	children?: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}) {
	return (
		<div className={`sidebar-header ${className || ""}`} style={style}>
			{children}
		</div>
	);
}
